export const SERVICE_NAME = 'events-ui';
export const USER_ME = 'me';
export const GRID_LIMIT = 8;
export const EVENT = 'event';
export const EVENTS = 'events';

export const TAB_IDS = {
  MY_EVENTS: 'my-events',
  BROWSE: 'browse-events',
};
export const LINKS = {
  HOME: '/',
  EVENT: '/:slug',
  EVENTS: '/events',
  CREATE_WITH_US: '/pages/co-create-with-us',
};
